<template>
    <rkm-area
    :title="title"
    type="fieldset"
    class="mt-3"
    >
        <rkm-col :visible="internalVisible">
            <rkm-row v-if="!disabled" class="flex-nowrap">
                <rkm-col>
                    <rkm-form-radio-group
                        label="Tipo de formulário"
                        :disabled="disabled"
                        :options="tipoFormularioAcidenteTrabalhoOptions"
                        v-model="data.model.acidenteTrabalho.tipoFormularioAcidenteTrabalho"
                        text-field="nome"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :disabled="disabled"
                        :validations="validations.empresaNome"
                        label="Empresa"
                        v-model="data.model.acidenteTrabalho.empresaNome"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input
                        :disabled="disabled"
                        :validations="validations.empresaRamoAtividade"
                        label="Ramo de atividade"
                        v-model="data.model.acidenteTrabalho.empresaRamoAtividade"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="9">
                    <rkm-form-input
                        :disabled="disabled"
                        :validations="validations.empresaEndereco"
                        label="Endereço da empresa"
                        v-model="data.model.acidenteTrabalho.empresaEndereco"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :disabled="disabled"
                        :validations="validations.empresaTelefone"
                        label="Telefone"
                        v-mask="telefoneMask"
                        v-model="data.model.acidenteTrabalho.empresaTelefone"
                    />
                </rkm-col>

                <rkm-col cols="12" v-if="mostraOcupacaoPaciente()">
                    <rkm-form-input
                        label="Ocupação do paciente"
                        :disabled="disabled"
                        v-model="data.model.acidenteTrabalho.empresaOcupacaoPaciente"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

        <rkm-area
            title="Identificação do Acidente"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-date-picker
                        :disabled="disabled"
                        :max-date="data.form.dataAtual"
                        :validations="validations.acidenteData"
                        label="Data"
                        v-model="data.model.acidenteTrabalho.acidenteData"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-time-picker
                        :disabled="disabled  || !data.model.acidenteTrabalho.acidenteData"
                        :validations="validations.acidenteHora"
                        label="Hora"
                        v-model="data.model.acidenteTrabalho.acidenteHora"
                    />
                </rkm-col>
                <rkm-col cols="6">
                    <rkm-form-radio-group
                        label="Acidente"
                        :options="data.form.raat.tipoAcidente"
                        :validations="validations.tipoAcidente"
                        :disabled="(centroCusto.setorId !== enums.setorTipo.CONSULTORIO) && (centroCusto.setorId !== enums.setorTipo.TRIAGEM)"
                        text-field="nome"
                        v-model="data.model.acidenteTrabalho.acidenteTipoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :disabled="disabled"
                        :validations="validations.acidenteLocal"
                        label="Local"
                        v-model="data.model.acidenteTrabalho.acidenteLocal"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :disabled="disabled"
                        :validations="validations.acidenteDescricao"
                        label="Descrição"
                        v-model="data.model.acidenteTrabalho.acidenteDescricao"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row class="flex-nowrap">
                <rkm-col>
                    <rkm-form-radio-group
                        label="Regime de trabalho"
                        :disabled="disabled"
                        :options="data.form.raat.regimeTrabalho"
                        :validations="validations.regimeTrabalho"
                        text-field="nome"
                        v-model="data.model.acidenteTrabalho.regimeTrabalhoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="data.model.acidenteTrabalho.regimeTrabalhoId === enums.regimeTrabalho.OUTRO">
                <rkm-col>
                    <rkm-form-input
                        :disabled="disabled"
                        :validations="validations.regimeTrabalhoOutro"
                        label="Outro"
                        v-model="data.model.acidenteTrabalho.regimeTrabalhoOutro"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-col>
    </rkm-area>
</template>

<script>
// Enums.
import regimeTrabalho from '@/enums/pronto-atendimento/raat/regimeTrabalho'
import tipoFormularioAcidenteTrabalho from '@/enums/pronto-atendimento/tipoFormularioAcidenteTrabalho'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Others.
import moment from 'moment'

// Mixins.
import { mask, repository } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ centroCusto: 'getCentroCusto' }),
        validations() {
            return {
                empresaNome: { min: 2, max: 150, required: this.internalVisible },
                empresaRamoAtividade: { required: this.internalVisible, min: 2, max: 150 },
                empresaEndereco: { min: 5, max: 150 },
                empresaTelefone: { min: 14, max: 15 },
                acidenteData: { required: this.internalVisible },
                acidenteHora: { required: this.internalVisible, max_hour: this.validaHora()},
                tipoAcidente: { required: this.internalVisible },
                acidenteLocal: { required: this.internalVisible, min: 3, max: 150 },
                acidenteDescricao: { min: 3, max: 250, required: this.internalVisible },
                regimeTrabalho: { required: this.internalVisible },
                regimeTrabalhoOutro: { required: this.internalVisible, min: 3, max: 150 },
            }
        },
        telefoneMask() {

            const numero = this.data.model.acidenteTrabalho.empresaTelefone

            if (!numero) {

                return ''
            }

            return numero.length < 15 ? this.mask.phone : this.mask.cellPhone
        },
        tipoFormularioAcidenteTrabalhoOptions() {
            return Object.keys(this.enums.tipoFormularioAcidenteTrabalho).map(key => ({
                nome: key,
                id: this.enums.tipoFormularioAcidenteTrabalho[key],
            }));
        },
    },
    created() {
        this.repositories = {
            dataHora: this.getConectaSusRepository('dataHora')
        };
    },
    data: () => ({
        enums: {
            regimeTrabalho,
            tipoFormularioAcidenteTrabalho,
            setorTipo,
        },
        dataHoraAtual: ''
    }),
    methods: {
        mostraOcupacaoPaciente() {
            if(this.disabled && this.data.model.acidenteTrabalho.tipoFormularioAcidenteTrabalho) {
                return parseInt(this.data.model.acidenteTrabalho.tipoFormularioAcidenteTrabalho) == this.enums.tipoFormularioAcidenteTrabalho.CAT;
            }
            return this.data.model.acidenteTrabalho.tipoFormularioAcidenteTrabalho != this.enums.tipoFormularioAcidenteTrabalho.RAAT;
        },
        resetForm(){
            this.data.model.acidenteTrabalho.empresaNome = "";
            this.data.model.acidenteTrabalho.empresaRamoAtividade = "";
            this.data.model.acidenteTrabalho.empresaEndereco = "";
            this.data.model.acidenteTrabalho.empresaTelefone = "";
            this.data.model.acidenteTrabalho.acidenteData = "";
            this.data.model.acidenteTrabalho.acidenteHora = "";
            this.data.model.acidenteTrabalho.acidenteTipoId = "";
            this.data.model.acidenteTrabalho.acidenteLocal = "";
            this.data.model.acidenteTrabalho.acidenteDescricao = "";
            this.data.model.acidenteTrabalho.regimeTrabalhoId = "";
            this.data.model.acidenteTrabalho.regimeTrabalhoOutro = "";
            this.data.model.acidenteTrabalho.sofreuAcidenteTrabalho = null;
            this.data.model.acidenteTrabalho.portadorDoencaOcupacional = null;
            this.data.model.acidenteTrabalho.precisaInternacao = null;
        },
        validaHora() {
            this.repositories.dataHora.get().then(r => this.dataHoraAtual = r.data);

            const tempoAtual = moment(this.dataHoraAtual, 'DD/MM/YYYY HH:mm');
            const comparaDatas = tempoAtual.diff(moment(this.data.model.acidenteTrabalho.acidenteData), 'days');

            if(comparaDatas > 0) {
                return false;
            }

            const horaAtual = tempoAtual.format('HH:mm');
            const horaInformada = moment(this.data.model.acidenteTrabalho.acidenteHora, 'HH:mm').format('HH:mm');

            if(horaInformada.replace(':', '') > horaAtual.replace(':', '')){
                return horaAtual;
            }

            return false;

        }
    },
    mixins: [ mask, repository ],
    props: {
        data: { type: Object, required: true },
        disabled: { type: Boolean },
        title: { type: String, required: false, default: "Acidente de trabalho" },
        internalVisible: { type: Boolean, required: false, default: false },
    },
}
</script>